/*  Shared  */
import { useQuery } from '@tanstack/react-query';
import { Response } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';
import { Tenant } from 'application/Shared/types/tenant';

/*  NPM  */
import axios from 'axios';

/*  React  */
import { useMemo } from 'react';

interface GetGlobalAdminTenantParams {
    global: boolean;
    id?: string;
    includeSettings: boolean;
    size: number;
}

export const useFetchGlobalAdminTenantById = ({
    enabled = true,
    tenantId
}: {
    tenantId?: string;
    enabled: boolean;
}) => {
    const params: GetGlobalAdminTenantParams = useMemo(
        () => ({
            global: true,
            id: tenantId,
            includeSettings: true,
            size: 1
        }),
        [tenantId]
    );

    const { data, isLoading, refetch } = useQuery<Tenant>({
        enabled: enabled && !!params.id,
        queryFn: async () =>
            axios
                .get('/tenant', {
                    params
                })
                .then((res) => {
                    // Use Response helper if available; otherwise, just return the data
                    if (!Response.hasData(res)) {
                        debug.w('No tenant found', res);
                        return null;
                    }

                    return Response.getOne(res);
                }),

        queryKey: ['tenant', params.id, params]
    });

    return {
        loading: isLoading,
        refetchData: refetch,
        tenant: data
    };
};
